/**
 * my-mcc.ts
 *
 * Import the JS for your My MCC sections/components here.
 *
 */
import ComponentInit from '../js/utils/ComponentInit';
import CardSettings from './Pages/CardSettings/CardSettings';
import EnterPin from './Pages/EnterPin/EnterPin';
import SignUpPanel from './Pages/SignUp/SignUpPanel';
import TopUp from './Pages/Topup/TopUp';
import Profile from './Pages/Profile/Profile';
import CommunicationPreferences from './Pages/CommunicationPreferences/CommunicationPreferences';
import TransactionHistory from './Pages/TransactionHistory/TransactionHistory';
import Notifications from './Pages/Notifications/Notifications';

const componentList = {
    CardSettings,
    EnterPin,
    SignUpPanel,
    TopUp,
    TransactionHistory,
    Profile,
    CommunicationPreferences,
    Notifications,
};

// eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
export default ComponentInit(componentList);
